<template lang="pug">
  .main-slider.camp-shift-slider
    .main-slider__btn.main-slider__btn_prev(
      v-if="sliderActive"
    )
      button.main-slider-button(
        @click.prevent="onArrowLeft()"
      )
    .main-slider__btn.main-slider__btn_next(
      v-if="sliderActive"
    )
      button.main-slider-button(
        @click="onArrowRight()"
      )
    .main-slider__body(
      v-touch:swipe.left="swipeHandlerLeft"
      v-touch:swipe.right="swipeHandlerRight"
    )
      .obj-list.obj-list_shifts(
        ref="shiftSlider"
        :style="sliderStyle"
      )
        .camp-shift-slider__item(
          v-for="slide in slides"
        )
          router-link.obj.obj_background.camp-shift-slider_background(
            :to="`/pages/shifts/${slide.id}/`"
          )
            .obj__media
              img(:src="slide.photos.length > 0 ? slide.photos[0].preview_376x340 : 'https://dummyimage.com/244x168/a15555/000000.jpg'")
            .obj__body
              .obj__name(v-if="slide.camp") {{slide.camp.name}}
              .obj__title {{slide.name}}
              .obj__date {{ slide.date_started | monthDayDate }} - {{ slide.date_finished | monthDayDate }}
</template>

<script>
export default {
  name: "ShiftsSlider",
  components: {},
  props: {
    sliderData: {
      type: Array,
      default: () => []
    },
    slidesCount: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      sliderTranslate: 0,
      shiftsData: [],
      slides: [],
      activeToTransform: true
    };
  },
  computed: {
    sliderDefaultTranslate() {
      if (this.sliderActive) {
        return this.rounding((100 / this.slides.length * this.slidesCount * -1), 4);
      } else {
        return 0;
      }
    },
    sliderStyle() {
      return {
        width: (100 / this.slidesCount) * this.slides.length + "%",
        transform: "translate(" + this.sliderDefaultTranslate + "%)"
      };
    },
    sliderActive() {
      if (this.sliderData.length <= this.slidesCount) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    rounding(num) {
      //округление до 4 цифр после запятой
      return Number(num.toFixed(4));
    },
    swipeHandlerLeft() {
      this.onArrowRight();
    },
    swipeHandlerRight() {
      this.onArrowLeft();
    },
    onArrowLeft() {
      if (!this.activeToTransform) {
        return;
      }
      const shiftSlider = this.$refs.shiftSlider;
      shiftSlider.style.transition = "all 0.5s";
      this.sliderTranslate += this.rounding((100 / this.slides.length));
      this.sliderTranslate = this.rounding(this.sliderTranslate);
      this.$refs.shiftSlider.style.transform =
        "translate(" + this.sliderTranslate + "%)";
      this.activeToTransform = false;
      setTimeout(() => {
        if (Math.ceil(this.sliderTranslate) >= 0) {
          this.$refs.shiftSlider.style.transition = "none";
          const translate = 0 - this.rounding((100 / this.slides.length * (this.slides.length - (this.slidesCount * 2))));
          this.$refs.shiftSlider.style.transform =
            "translate(" + translate + "%)";
          this.sliderTranslate = translate;
        }
        this.activeToTransform = true;
      }, 500);
    },
    onArrowRight() {
      if (!this.activeToTransform) {
        return;
      }
      const shiftSlider = this.$refs.shiftSlider;
      shiftSlider.style.transition = "all 0.5s";
      this.sliderTranslate -= this.rounding((100 / this.slides.length));
      this.sliderTranslate = this.rounding(this.sliderTranslate);
      this.$refs.shiftSlider.style.transform =
        "translate(" + this.sliderTranslate + "%)";
      this.activeToTransform = false;

      setTimeout(() => {
        if (Math.floor(this.sliderTranslate - 100 / this.slides.length * this.slidesCount) <= -100) {
          this.$refs.shiftSlider.style.transition = "none";
          //let translate = 0 - this.rounding((100 / this.slides.length * (this.slides.length - (this.slidesCount * 2))));
          this.$refs.shiftSlider.style.transform =
            "translate(" + this.sliderDefaultTranslate + "%)";
          this.sliderTranslate = this.sliderDefaultTranslate;
        }
        this.activeToTransform = true;
      }, 500);
    },

    createSliderData(data) {
      this.slides = data;

      const cloneAfter = [];
      const cloneBefore = [];

      for (var i = 0; i < this.slidesCount; i++) {
        cloneAfter.push(this.sliderData[i]);
        cloneBefore.unshift(this.sliderData[this.sliderData.length - 1 - i]);
      }
      this.slides = cloneBefore.concat(this.sliderData, cloneAfter);
      this.sliderTranslate = this.sliderDefaultTranslate;
    }
  },
  mounted() {
    if (this.sliderActive) {
      this.createSliderData(this.sliderData);
    } else {
      this.slides = this.sliderData;
    }
  },
  watch: {
    sliderData(data) {
      if (this.sliderActive) {
        this.createSliderData(data);
      } else {
        this.slides = data;
      }
    },
    slidesCount() {
      if (this.sliderActive) {
        this.createSliderData(this.sliderData);
      } else {
        this.slides = this.sliderData;
      }
    }
  }
};
</script>
